import * as React from 'react'
import { makeStyles } from '@mui/styles'

import { Theme } from '../../design-tokens/theme'
import Avatar from '../../primitives/Avatar'
import Flex from '../../primitives/Flex'
import Text from '../../primitives/Text'

interface Props {
  name: string
  avatar?: string
  disabled?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  container: ({ disabled }: { disabled: boolean }) => ({
    cursor: disabled ? 'auto' : 'pointer',
  }),
  displayDesktop: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))

const UserWrapper = ({ name, avatar, disabled }: Props) => {
  const classes = useStyles({ disabled: Boolean(disabled) })

  return (
    <Flex alignItems="center" className={classes.container}>
      <Avatar src={avatar} size="small">
        {!avatar && name}
      </Avatar>
      <Text marginLeft="dense" color="white" size="small" textTransform="uppercase" className={classes.displayDesktop}>
        {name.toLowerCase()}
      </Text>
    </Flex>
  )
}

UserWrapper.defaultProps = {
  disabled: false,
}

export default UserWrapper
